(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Elements
  const items = document.querySelectorAll('.lookbook-item');
  const popup = document.getElementById('lookbookPopup');
 const closeBtn = popup.querySelector('.lookbook-popup-close');
  const swiperContainer = popup ? popup.querySelector('.lookbookSwiper') : null;
  const progressBars = document.querySelectorAll('.progress-bar-item');

  // Drawer elements
  const drawer = document.getElementById('lookbookDrawer');
  const closeDrawer = drawer ? drawer.querySelector('.drawer-close') : null;
  const allCollections = drawer ? drawer.querySelectorAll('.drawer-collection') : [];

  // Safe Swiper init helper
  let swiper = null;
  function initSwiper(startIndex) {
    // don't crash if Swiper not loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not found — skipping Swiper init.');
      return;
    }

    try {
      if (swiper) {
        try { swiper.destroy(true, true); } catch (e) { /* ignore */ }
        swiper = null;
      }

      swiper = new Swiper(swiperContainer, {
        initialSlide: Number.isFinite(startIndex) ? startIndex : 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        on: {
          slideChange: function () {
            updateProgress(this.activeIndex);
          }
        }
      });
    } catch (err) {
      console.error('Error initializing Swiper:', err);
    }
  }

  // Open popup when grid item clicked
  items.forEach(item => {
    item.addEventListener('click', function () {
      // determine index safely
      const idx = Number(item.dataset.index);
      const index = Number.isFinite(idx) ? idx : 0;

      if (popup) {
        popup.classList.add('active');
        popup.setAttribute('aria-hidden', 'false');
      }

      if (swiperContainer) {
        initSwiper(index);
        // if swiper not available, still update progress
        updateProgress(index);
        if (swiper && typeof swiper.slideTo === 'function') {
          swiper.slideTo(index);
        }
      }
    });
  });

  // Popup close handlers
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (popup) popup.classList.remove('active');
    });
  }
  if (popup) {
    popup.addEventListener('click', (e) => {
      if (e.target === popup) popup.classList.remove('active');
    });
  }
closeBtn.addEventListener('click', () => {
  popup.classList.remove('active');
});
  function updateProgress(activeIndex) {
    progressBars.forEach((bar, i) => {
      bar.classList.toggle('active', i === activeIndex);
    });
  }

  // === Drawer behavior ===
  // Hide all drawer collections initially (so markup is present but hidden)
  if (allCollections && allCollections.length) {
    allCollections.forEach(c => c.style.display = 'none');
  }

  // Click handler for Shop the Look buttons inside popup slides
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.lookbook-shop-btn');
    if (!btn) return;

    const collectionHandle = btn.getAttribute('data-collection') || btn.getAttribute('data-collection-handle');
    if (!collectionHandle) {
      console.warn('Shop the Look button clicked but no data-collection found.');
      return;
    }

    // find matching drawer block by data-collection-handle
    let target = null;
    if (allCollections && allCollections.length) {
      for (let i = 0; i < allCollections.length; i++) {
        const col = allCollections[i];
        const handle = col.getAttribute('data-collection-handle');
        if (handle && handle === collectionHandle) {
          target = col;
          break;
        }
      }
    }

    // fallback: try by id that includes handle (older approach)
    if (!target && allCollections && allCollections.length) {
      target = Array.from(allCollections).find(col => col.id && col.id.indexOf(collectionHandle) !== -1);
    }

    // hide all and show only target
    if (allCollections && allCollections.length) {
      allCollections.forEach(c => c.style.display = 'none');
    }
    if (target) {
  target.style.display = 'block';
  // open drawer but keep popup visible
  if (drawer) drawer.classList.add('active');
} else {
  console.warn('No matching drawer block found for collection handle:', collectionHandle);
}
  });

  // close drawer
  if (closeDrawer) {
    closeDrawer.addEventListener('click', function () {
      if (drawer) drawer.classList.remove('active');
    });
  }

  // Safety: click outside drawer to close (optional)
  document.addEventListener('click', function (e) {
    if (!drawer) return;
    const isClickInside = drawer.contains(e.target) || (e.target.closest('.popup-lookbook-btn') !== null) || (e.target.closest('.lookbook-popup') !== null);
    // do nothing if click is inside drawer or popup or the popup button
    if (isClickInside) return;
    // otherwise close drawer if open
    if (drawer.classList.contains('active')) drawer.classList.remove('active');
  });
});
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('lookbookPopup');
  const drawer = document.getElementById('lookbookDrawer');
  const popupCloseBtn = popup.querySelector('.lookbook-close');

  popupCloseBtn.addEventListener('click', () => {
    popup.classList.remove('active');  // close popup
    drawer.classList.remove('active'); // also close drawer
  });
});


  } catch(e) { console.error(e); }
})();
})();
